module.exports = __webpack_public_path__ + "img/social3.c647049a.png";